export const pageValidater = (value) => {
  switch (typeof value.value) {
  case 'number':
    if (value.operand === '<' && value.value === 0) {
      return false;
    }
    return true;
  case 'string':
    return !!value.value;
  case 'object': {
    const { startValue } = value.value;
    const { endValue } = value.value;
    return !!startValue && !!endValue;
  }
  default:
    return false;
  }
};
export const selectValidator = value => !!(value.length && value.length > 0);
export const selectTwoLevelValidator = value => !!(value && value.value && value.value.length > 0);
export default pageValidater;
